import React from 'react';
import {
  bool, string, object, arrayOf, shape
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import classNames from 'classnames/bind';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Row, Col } from '@thd-olt-component-react/grid';
import { ProductGrid } from './ProductGrid';
import styles from '../dynamic-broad-intent-aisle.module.scss';

export const Aisle = ({ aisle, isMobile, storeId }) => {

  const cx = classNames.bind(styles);
  const { aisle: categories, aisleCategory, aisleBrand, shopAllUrl } = aisle;
  const header = isMobile ? aisleCategory : `Featured ${aisleCategory}`;

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div>
      <Row>
        <Col xs="12" className={cx({ 'dynamic-broad-intent-aisle-mobile-card': isMobile })}>
          <Row className={cx('section-heading__title', 'dynamic-broad-intent-aisle__header')}>
            <Col xs="12" className={cx({ 'dynamic-broad-intent-aisle__col-no-padding': isMobile })}>
              <span className={cx({ 'dynamic-broad-intent-aisle__header-underline': isMobile })}>
                {header}
              </span>
              <a className={cx('dynamic-broad-intent-aisle__header-link')} href={shopAllUrl}>
                Shop All
              </a>
            </Col>
          </Row>
          {isMobile
            ? (
              <Row>
                <Col xs="12" className={cx('dynamic-broad-intent-aisle__col-no-padding')}>
                  <Carousel
                    itemWidthMobile="45"
                    itemClass={cx('dynamic-broad-intent-aisle__pod')}
                  >
                    {(categories).map((card, index) => {
                      if (!card.products || card.products.length === 0) return null;
                      return (
                        <ProductGrid
                          title={card.displayName}
                          storeId={storeId}
                          categoryKey={card.name}
                          products={card.products}
                          key={`category-${index}-${aisleBrand}`}
                          shopAllUrl={card.shopAllUrl}
                          isMobile
                        />
                      );
                    })}
                  </Carousel>
                </Col>
              </Row>
            )
            : (
              <Row className={cx('dynamic-broad-intent-aisle__row')}>
                {(categories).map((card, index) => {
                  if (!card.products || card.products.length === 0) return null;
                  return (
                    <Col
                      xs={12 / categories.length}
                      key={`category_${index}`}
                      className={cx('dynamic-broad-intent-aisle__col')}
                    >
                      <ProductGrid
                        storeId={storeId}
                        title={card.displayName}
                        categoryKey={card.name}
                        products={card.products}
                        shopAllUrl={card.shopAllUrl}
                      />
                    </Col>
                  );
                })}
              </Row>
            )}
        </Col>
      </Row>
    </div>
  );
};

Aisle.displayName = 'Aisle';
Aisle.dataModel = extend({}, ProductGrid);

Aisle.propTypes = {
  storeId: string.isRequired,
  aisle: shape({
    aisleCategory: string,
    aisleBrand: string,
    aislePosition: string,
    shopAllUrl: string,
    products: arrayOf(shape({
      name: string,
      shopAllUrl: string,
      // eslint-disable-next-line react/forbid-prop-types
      skus: arrayOf(object)
    }))
  }).isRequired,
  isMobile: bool
};

Aisle.defaultProps = {
  isMobile: false
};
